<template>
  <div>
    <span class="spinner-border spinner-border-sm me-2" v-if="isShowLoading()"></span>
    <span v-if="isTypeTelegram()">
      <svg @click="onRemove(data['post_id'])" :class="{'disabled': !isShowDeleteBtn()}" xmlns="http://www.w3.org/2000/svg" class="post-remove__fast icon icon-tabler icon-tabler-trash" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <line x1="4" y1="7" x2="20" y2="7"></line>
        <line x1="10" y1="11" x2="10" y2="17"></line>
        <line x1="14" y1="11" x2="14" y2="17"></line>
        <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"></path>
        <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"></path>
      </svg>
    </span>
    <span v-if="isTypeSite()">
      <svg @click="onRemove(data['post_id'])" :class="{'disabled': !isShowDeleteBtn()}" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
           class="post-remove__fast icon icon-tabler icons-tabler-outline icon-tabler-bulb-off me-1"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path
          d="M3 12h1m8 -9v1m8 8h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7"/><path
          d="M11.089 7.083a5 5 0 0 1 5.826 5.84m-1.378 2.611a5.012 5.012 0 0 1 -.537 .466a3.5 3.5 0 0 0 -1 3a2 2 0 1 1 -4 0a3.5 3.5 0 0 0 -1 -3a5 5 0 0 1 -.528 -7.544"/><path
          d="M9.7 17h4.6"/><path d="M3 3l18 18"/>
      </svg>
    </span>
  </div>
</template>

<script>
import {defineComponent, ref} from "vue"
import "./css/style.css"
import Api from "@/modules/post/components/list/services/Api"
import Notify from "@/services/Notify"

export default defineComponent({
  name: "PostRemove",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  setup(props, {emit}) {
    let deleting = ref(false)

    let type = ref(props.data["type"])

    function startDeleting() {
      deleting.value = true
    }

    function stopDeleting() {
      deleting.value = false
    }

    function isDeleting() {
      return deleting.value === true
    }

    function isShowDeleteBtn() {
      return !isDeleting()
    }

    function isShowLoading() {
      return isDeleting()
    }

    function onRemove(postId) {
      let quersion = ""

      if (isTypeSite()) {
        quersion = "Вы действительно хотите выключить пост?"
      }

      if (isTypeTelegram()) {
        quersion = "Вы действительно хотите удалить пост?"
      }

      if (confirm(quersion)) {
        startDeleting()

        let handler

        if (isTypeTelegram()) {
          handler = Api.telegramDelete(postId)
        } else if (isTypeSite()) {
          handler = Api.siteDelete(postId)
        } else {
          throw new Error("Неверный тип")
        }

        handler.then(() => {
          emit('onRemove', true)
        }).then(() => {
          if (isTypeSite()) {
            Notify.success("Поставлена задача на выключение")
          }

          if (isTypeTelegram()) {
            Notify.success("Поставлена задача на удаление")
          }
        }).catch(() => {
          emit('onRemove', false)
        }).catch(() => {
          if (isTypeSite()) {
            Notify.success("Возникла ошибка при выключении")
          }

          if (isTypeTelegram()) {
            Notify.success("Возникла ошибка при удалении")
          }
        }).finally(() => {
          stopDeleting()
        })
      }
    }

    function isTypeTelegram() {
      return type.value === "telegram"
    }

    function isTypeSite() {
      return type.value === "site"
    }

    return {
      onRemove,
      isShowDeleteBtn,
      isShowLoading,
      isTypeTelegram,
      isTypeSite,
    }
  }
})
</script>

<style scoped>

</style>